var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{staticClass:"form-control",attrs:{"type":"text","size":"sm","placeholder":_vm.placeholder,"value":_vm.val,"name":_vm.name,"maxlength":10,"state":_vm.state,"size":_vm.size},on:{"input":function (val) { return _vm._onInput(val); },"change":function (val) { return _vm._onChange(val); }}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b109fe6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Form/ZipCode.vue
// module id = 0Ky4
// module chunks = 1